


















import { Component, Vue } from 'vue-property-decorator';
import ImageManager from '@/script/ImageManager';
import TextManager from '@/script/TextManager';
import {getSizeRatio, Size} from '@/script/common';

@Component
export default class Introduction extends Vue {
  private logo: string = ImageManager.INSTANCE.get('Twitterロゴ')!;
  private frame: string = ImageManager.INSTANCE.get('猫フレーム')!;
  private eventName: string = TextManager.INSTANCE.get('site-title')!;
  private twitterMsg: string = TextManager.INSTANCE.get('twitter-text')!;
  private twitterUrl: string = TextManager.INSTANCE.get('twitter-url')!;
  private twitterId: string = TextManager.INSTANCE.get('twitter-id')!;
  private introductionText: string = TextManager.INSTANCE.get('introduction-text')!;

  private frameSize: Size = { width: 673, height: 476 };
  private fontSize: number = 18;
  private paddingTop: number = 70;
  private paddingHorizontal: number = 30;
  private paddingBottom: number = 45;

  private created() {
    window.addEventListener('resize', this.onResize);
    this.onResize();
  }

  private onResize() {
    // フレームのサイズを調整
    const frameWidth = 673;
    const sizeRatio = getSizeRatio(frameWidth);

    this.frameSize.width = frameWidth * sizeRatio;
    this.frameSize.height = this.frameSize.width * 0.7;

    this.fontSize = Math.max(10, 18 * sizeRatio);
    this.paddingTop = 70 * sizeRatio;
    this.paddingHorizontal = 30 * sizeRatio;
    this.paddingBottom = 45 * sizeRatio;
  }

  private openNoticeAccountUrl() {
    window.open(this.twitterUrl, '_blank');
  }

  private get frameStyle() {
    return {
      '--image-url': `url(${this.frame})`,
      'width': `${this.frameSize.width}px`,
      'height': `${this.frameSize.height}px`,
      'fontSize': `${this.fontSize}px`,
      'paddingTop': `${this.paddingTop}px`,
      'paddingLeft': `${this.paddingHorizontal}px`,
      'paddingRight': `${this.paddingHorizontal}px`,
      'paddingBottom': `${this.paddingBottom}px`,
    };
  }
}
